export default "__VITE_ASSET__BkOAF5lM__"